<template>
  <div class="">

    <div class="load" v-if="spinning == true">
      <a-spin :spinning="spinning" tip="Loading..."></a-spin>
    </div>

    <div id="components-form-demo-advanced-search">
      <a-form
              class="ant-advanced-search-form"
      >
        <a-row :gutter="24">
          <a-col :span="4" :style="{ textAlign: 'right' }">
            <a-form-item label="垛二维码：">
              {{wallInfo.no}}
            </a-form-item>
          </a-col>

          <a-col :span="8" :style="{ textAlign: 'right' }">
            <a-button type="primary" @click="toCreate">
              添加
            </a-button>

            <a-button type="primary" :style="{ marginLeft: '8px' }" @click="goBack">
              返回
            </a-button>


          </a-col>
        </a-row>
      </a-form>
      <!-- 表格 -->
      <div class="table">
        <a-table
                :columns="columns"
                :dataSource="dataList"
                :pagination="pagination"
                rowKey="id"
                @change="TableChange"
        >
          <template slot="serial" slot-scope="text, record, index">
            <template>
              {{ ((pagination.current - 1)*pagination.pageSize) + (index+1) }}
            </template>
          </template>
          <a slot="name" slot-scope="text">{{ text }}</a>

          <template slot="covidResist" slot-scope="text, record, index">
            <template>
              {{text | trueFilter}}
            </template>
          </template>

          <template slot="sampleDate" slot-scope="text, record, index">
            <template>
              {{text | sampleDateFilter}}
            </template>
          </template>



          <template slot="opera" slot-scope="text,record">
            <a-tag slot="opera" color="green" @click="toEdit(record)"  style="cursor: pointer;">
              修改
            </a-tag>

            <a-tag slot="opera" color="red" @click="toDelete(record)"  style="cursor: pointer;">
              删除
            </a-tag>
          </template>
        </a-table>

      </div>
    </div>

    <!-- 删除弹框 -->
    <div>
      <a-modal
              title="堆垛二维码管理"
              :visible="visible"
              :confirm-loading="confirmLoading"
              @ok="handleOk"
              @cancel="handleCancel"
              ok-text="确认" cancel-text="取消"
      >
        <a-card class="card" title="基础信息" :bordered="false">
          <a-row class="form-row" :gutter="16">
            <a-col :lg="24" :md="24" :sm="24">
              <a-form-model-item ref="wallRow" prop="wallRow" label="行">
                <a-input
                        placeholder="请输入行号"
                        v-model="form.wallRow"
                />
              </a-form-model-item>
            </a-col>

            <a-col :lg="24" :md="24" :sm="24">
              <a-form-model-item ref="wallCol" prop="wallCol" label="列">
                <a-input
                        placeholder="请输入列号"
                        v-model="form.wallCol"
                />
              </a-form-model-item>
            </a-col>
            <a-col :lg="24" :md="24" :sm="24">
              <a-form-model-item ref="code" prop="code" label="二维码">
                <a-input
                        placeholder="请输入二维码值"
                        v-model="form.code"
                />
              </a-form-model-item>
            </a-col>
          </a-row>


        </a-card>
      </a-modal>
    </div>
  </div>
</template>

<script>

import { addCode, codeInfo, updateCode,deleteCode,codeList } from "@/api/wall/code";
import { wallInfo } from "@/api/wall/wall";


import { demoList } from '@/api/demo/demo'
import moment from "moment";


const columns = [
  {
    title: "序号 ",
    dataIndex: "serial",
    key: "serial",
    align: "center",
    scopedSlots: {customRender: 'serial'}
  },
  {
    title: "行 ",
    dataIndex: "wallRow",
    key: "wallRow",
    align: "center"
  },
  {
    title: "列 ",
    dataIndex: "wallCol",
    key: "wallCol",
    align: "center"
  },
  {
    title: "二维码",
    key: "code",
    dataIndex: "code",
    align: "center",
    scopedSlots: {customRender: 'code'}
  },
  {
    title: "操作 ",
    key: "opera",
    dataIndex: "opera",
    scopedSlots: {customRender: "opera"}
  }
];

const dataList = [];

export default {
  data() {
    return {
      dateFormat: "YYYY/MM/DD HH:mm:ss",
      moment,
      pagination: {
        current: 1,
        pageNo: 1,
        pageSize: 10, // 默认每页显示数量
        showSizeChanger: true, // 显示可改变每页数量
        pageSizeOptions: ['10', '20', '30'], // 每页数量选项
        showTotal: total => `共有 ${total} 条`, // 显示总数
        // //onChange: (page, pageSize) => this.changePage(page, pageSize), // 点击页码事件
        total: 0 // 总条数
      },

      param:{
        size: 10,
        page: 1,
        wallId:""
      },
      dataList,
      columns,
      ModalText: '确定要删除该信息吗？',
      visible: false,
      confirmLoading: false,

      form: {
        id: undefined,
        wallRow: 1,
        wallCol: 1,
        code: "",
      },

      id: 0,

      demoList:[],
      wallInfo:{},
      spinning: false,

    };
  },
  created() {
    // 获取区划列表
    this.getDemo();
    if (this.$route.query.id) {

      this.param.wallId = this.$route.query.id;
      wallInfo({
        wallId: this.param.wallId
      }).then(res => {
        if (res.code == 0) {
          this.wallInfo = res.data;
        }
      });
      this.getList(0)
    }

  },
  methods: {

    getDemo () {
      demoList({
        page:1,
        size:100
      }).then(res => {
        this.demoList = res.data.list
      });
    },

    getList(number) {
      if (number === 0) {
        this.pagination.current = 1
        this.param.page = 1
      }

      var param = this.param

      codeList(param).then(response => {
        this.dataList = response.data.list
        if (this.dataList) {
          this.pagination.total = response.data.total
        }
      })
    },
    // 搜索
    handleSearch(e) {
      e.preventDefault();
      this.getList(0);
    },

    toDelete (record) {
      var self = this
      this.$confirm({
        title: '确认删除',
        content: `是否确认删除当前信息？`,
        cancelText: '取消',
        okText: '确定',
        okType: 'danger',
        onOk () {
          return new Promise((resolve, reject) => {
            deleteCode({ codeId: record.id }).then(response => {
              self.$message.error('删除成功')
              self.getList()
            }).catch((e) => {

            }).finally(() => {
              resolve()
            })
          })
        }
      })
    },
    goBack () {
      this.$router.back()
    },


    //打开删除弹框
    toCreate() {
      //新建
      this.form.id = 0;
      this.form.wallRow = 0;
      this.form.wallCol = 0;
      this.form.code = "";
      this.visible = true;
    },
    toEdit(record) {
      //新建
      this.form = record;
      this.visible = true;
    },
    //确定删除
    handleOk() {

      this.visible = false;
      if(this.form.id == 0)
      {
        //添加
        this.addCode()

      }
      else {
        //保存
        this.updateCode()
      }
    },
    //取消删除
    handleCancel() {
      this.visible = false;
    },


    addCode() {
      let _this = this;
      addCode({
        demoId: _this.wallInfo.demoId,
        wallId: _this.wallInfo.id,
        wallNo: _this.wallInfo.no,
        wallRow: _this.form.wallRow,
        wallCol: _this.form.wallCol,
        code: _this.form.code,
        codeIdx: (_this.form.wallRow - 1) * 3 + _this.form.wallCol,
        status: 1
      }).then(res => {
        if (res.code == 0) {
          _this.$message.success("新增成功", function() {
            _this.getList(0);
          });
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    updateCode() {
      let _this = this;
      let data = {
        id: _this.form.id,

        demoId: _this.wallInfo.demoId,
        wallId: _this.wallInfo.id,
        wallNo: _this.wallInfo.no,
        wallRow: _this.form.wallRow,
        wallCol: _this.form.wallCol,
        code: _this.form.code,
        codeIdx: (_this.form.wallRow - 1) * 3 + _this.form.wallCol,
        status: 1
      };

      updateCode(data).then(res => {
        console.log(res);
        if (res.code == 0) {
          _this.$message.success("编辑成功", function() {
            //刷新
            _this.getList(0)
          });
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    TableChange(e) {
      // 每页数量变更
      this.pagination.current = e.current
      this.param.page = e.current
      this.param.size = e.pageSize

      this.getList()
    },
    changePage(page, pageSize) {
      // 页码变更
      this.pagination.current = page
      this.param.page = page
      this.param.size = pageSize

      this.getList()
    },


  }
};
</script>

<style lang="less" scoped>
  .card{
    margin-bottom: 24px;
  }
</style>
